import React, {Component} from 'react';

import Main from './pages/main.js';
import Nav from './components/nav.js';

import './global.css';

class Assembly extends Component {
  render() {
    return (
      <div>
        <Nav/>
        <Main/>
      </div>
    );
  }
}

export default Assembly;
